import {Component, OnInit, ViewChild, ElementRef, AfterViewInit} from '@angular/core';
import {MessageService} from '../../../core/services/message.service';
import {Notification} from '../../models/notification';
import {environment} from '../../../../environments/environment';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'notification-panel',
    templateUrl: './notification-panel.component.html',
    styleUrls: ['./notification-panel.component.css']
})

export class NotificationComponent implements OnInit {
    notifications: Notification[] = [];
    maxNotification: number = Math.abs(environment.common.notification_limit - 1) || 100;
    notificationTitle = '';

    constructor( private messageService: MessageService,  private translate: TranslateService) {}

    ngOnInit() {

        this.notificationTitle = this.translate.instant('title.notification-panel');

        this.messageService.onNotification().subscribe(notification => {
            if (notification) {
                this.notifications.unshift(notification);
            }
        });

        const notifContantainer = document.getElementById('notif-main'),
            notifButton = document.getElementById('panel-button'),
            notifClose = document.getElementById('panel-close');

        notifButton.addEventListener('click', function (e) {
            notifContantainer.className += ' active-panel';
        });

        notifClose.addEventListener('click', function (e) {
            notifContantainer.classList.remove('active-panel');
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/notification-panel/notification-panel.component.ts